import { useSheetContext } from "@/context/sheet";
import { useCreateService } from "@/hooks/services";
import { CreateService } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(services)/services/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateService({
    onSuccess: (service) => {
      close(() => {
        navigate({
          to: "/services",
          params: { id: service.id.toString() },
        });
      });
    },
  });

  const create = async (service: CreateService) => {
    await mutateAsync(service);
  };

  return <Form onUpsert={create} />;
}
